<template>
  <div style="padding: 10px;overflow: hidden;">
    <div class="biaotou">
      Huayin Group Service Agreement
    </div>
    <div class="neirong">
      Please be sure to read and understand all the rights and obligations stipulated in this "Service Agreement"
      (hereinafter referred to as the "Agreement") carefully. Unless you accept the terms of this agreement, you have no
      right to use this "Huayin Group" and its related services. Once you access or otherwise use this software product,
      it will be regarded as your acceptance of this agreement, indicating that you agree to be bound by all the terms
      of this agreement. If you do not agree to the terms in this agreement, please do not use this software.
    </div>
    <div class="neirong">
      This agreement is a legal agreement between the user and Huayin Brothers Group Co., LTD. (hereinafter referred to
      as "the Company") regarding the user's downloading, installation, use and copying of the Huayin Brothers Group
      (hereinafter referred to as "the Software") attached to this agreement.
    </div>
    <div class="neirong" style="font-weight: bold;">
      1. Declaration of Rights
    </div>
    <div class="neirong">
      All intellectual property rights of this "Software" and all information related to the "Software", including but
      not limited to: The text expressions and their combinations, ICONS, graphics, images, charts, colors, interface
      designs, layout frameworks, related data, additional programs, printed materials or electronic documents, etc. are
      all owned by our company and are protected by the Copyright Law of the People's Republic of China, international
      copyright treaties and other relevant intellectual property laws and regulations.
    </div>
    <div class="neirong" style="font-weight: bold;">
      2. Scope of Permission
    </div>
    <div class="neirong">
      2.1 Download, Installation and Use: This software is free of charge. Users can download, install and use this
      software in a non-commercial and unlimited quantity.
    </div>
    <div class="neirong">
      2.2 Copying, Distribution and Dissemination: Users may copy, distribute and disseminate this software product in a
      non-commercial and unlimited quantity. However, it must be ensured that every copy, distribution and dissemination
      is complete and true, including all software, electronic documents, Copyrights and trademarks related to this
      software product, as well as this agreement.
    </div>
    <div class="neirong" style="font-weight: bold;">
      3. Limitations of Rights
    </div>
    <div class="neirong">
      3.1 Prohibition of Reverse engineering, Decompile and disassembly: Users are not allowed to Reverse Engineer,
      decompile or Disassemble this software product, and at the same time, they are not allowed to modify any resources
      compiled within the program files. Except as explicitly permitted by laws and regulations for the above
      activities, users must abide by the restrictions of this agreement.
    </div>
    <div class="neirong">
      3.2 Component Division: This software product is licensed for use as a single product, and users are not allowed
      to separate the various parts for any purpose.
    </div>
    <div class="neirong">
      3.3 Non-Commercial Use: This software is free of charge. Users are not allowed to sell, copy or distribute it for
      commercial purposes, including but not limited to software sales, pre-installation, bundling, etc.
    </div>
    <div class="neirong">
      3.4 Reservation of Rights: All other rights not expressly authorized in this agreement remain the property of our
      Company. Users must obtain the written consent of our Company before using any other rights.
    </div>
    <div class="neirong" style="font-weight: bold;">
      4. User Instructions
    </div>
    <div class="neirong">
      4.1 This software provides services such as user registration, login, product browsing, and customer service
      consultation. This company reserves the right to adjust the service content and service mode from time to time. If
      you do not accept the adjusted service content and service mode, please stop using this software.
    </div>
    <div class="neirong">
      4.2 This software is only applicable to Android/ IOS operating systems. If users wish to abandon the use of this
      software for any reason after installation, they can uninstall it.
    </div>
    <div class="neirong">
      4.3 The network usage fees and data traffic fees incurred during the use of this software shall be paid by the
      user to the network service provider by themselves.
    </div>
    <div class="neirong">
      4.4 This software is provided with product and technical support by our company. Please upgrade the software to
      the latest version in a timely manner. After the release of a new version, the old version will no longer be
      maintained. Our company reserves the right to stop and continue supporting and maintaining a certain version.
    </div>
    <div class="neirong">
      4.5 Software Modification and Upgrade: Our company reserves the right to provide users with modified or upgraded
      versions of this software.
    </div>
    <div class="neirong">
      4.6 Product Inclusion: The user hereby agrees that in order to enhance the user experience, the Company may attach
      other related products of the company to this software for the user to download and install independently.
    </div>
    <div class="neirong">
      4.7 This software does not contain any malicious code aimed at destroying the user's operating system data or
      obtaining the user's private information. It does not contain any functional code for tracking or monitoring the
      user's operating system. It will not monitor the user's online or offline behavior, will not collect the user's
      personal information such as the use of other software or documents, and will not disclose the user's privacy.
    </div>
    <div class="neirong">
      4.8 Users shall use this software in compliance with the law and this agreement. Users have no right to carry out
      acts including but not limited to the following:
    </div>
    <div class="neirong">
      4.8.1 No rights management electronic information on this software shall be deleted or altered.
    </div>
    <div class="neirong">
      4.8.2 It is prohibited to intentionally circumvent or undermine the technical measures taken by the copyright
      owner to protect the copyright of this software.
    </div>
    <div class="neirong">
      4.8.3 Users shall not use this software to mislead or deceive others.
    </div>
    <div class="neirong">
      4.8.4 Violating national regulations by deleting, modifying, adding or interfering with the functions of the
      operating system, resulting in the operating system being unable to operate normally;
    </div>
    <div class="neirong">
      4.8.5 Disrupting the normal operation of this software system or website, and deliberately spreading computer
      viruses and other destructive programs;
    </div>
    <div class="neirong">
      4.8.6 Any other acts that endanger the security of computer information networks;
    </div>
    <div class="neirong">
      4.9 For this software product downloaded from sites not designated by our company and obtained from media not
      distributed by our company, our company cannot guarantee the security of such software. The use of such software
      may lead to unpredictable risks. It is recommended that users do not download, install or use it easily. Our
      company does not bear any legal responsibility arising therefrom.
    </div>
    <div class="neirong">
      4.10 Any pictures, videos, applications or other materials uploaded, published, transmitted, shared or downloaded
      through the services provided by this software, whether publicly or privately transmitted, shall be the
      responsibility of the user. Users shall independently bear legal responsibility for their actions carried out on
      this software.
    </div>
    <div class="neirong">
      4.11 Any content uploaded, published, transmitted, shared, shared or downloaded by users using this software shall
      comply with the relevant provisions of the current national laws and regulations and shall not contain the
      following contents:
    </div>
    <div class="neirong">
      4.11.1 Violating the basic principles determined by the Constitution; Containing other contents prohibited by laws
      and administrative regulations;
    </div>
    <div class="neirong">
      4.11.2 Endangering national security, disclosing state secrets, subverting state power and undermining national
      unity;
    </div>
    <div class="neirong">
      4.11.3 Damaging the honor and interests of the state, attacking the Party and the government and their leaders;
    </div>
    <div class="neirong">
      4.11.4 Inciting ethnic hatred or discrimination and undermining ethnic unity;
    </div>
    <div class="neirong">
      4.11.5 Inciting illegal assemblies, associations, processions, demonstrations or gatherings of people to disrupt
      social order, and conducting activities in the name of illegal non-governmental organizations;
    </div>
    <div class="neirong">
      4.11.6 Those who undermine the state's religious policies and promote cults and feudal superstitions;
    </div>
    <div class="neirong">
      4.11.7 Spreading rumors or false information, disrupting social order and undermining social stability;
    </div>
    <div class="neirong">
      4.11.8 Spreading reactionary, obscene, pornographic, gambling, violent, homicidal, terrorist or inciting crimes;
    </div>
    <div class="neirong">
      4.11.9 False, harassing, insulting, threatening, harmful, provocative and vulgar information;
    </div>
    <div class="neirong">
      4.11.10 Violating traditional virtues of the Chinese nation, social morality, ethics and morality, as well as
      socialist spiritual civilization;
    </div>
    <div class="neirong">
      4.11.11 Remarks and messages that promote racial discrimination and undermine national, ethnic or regional unity;
    </div>
    <div class="neirong">
      4.11.12 Infringing upon others' rights to portrait, name, reputation, privacy or other personal rights;
    </div>
    <div class="neirong">
      4.11.13 Information that infringes upon the patent rights, Copyrights, authorship rights, trademark rights,
      reputation rights or any other legitimate rights and interests of any other third party.
    </div>
    <div class="neirong">
      4.11.14 Where there are other contents prohibited by laws, administrative regulations and national provisions.
      Users shall bear all civil, administrative or criminal legal responsibilities resulting from improper uploading,
      Posting, transmission, sharing, sharing or downloading of information by themselves.
    </div>
    <div class="neirong">
      4.12 Privacy Protection
    </div>
    <div class="neirong">
      4.12.1 Our company has formulated strict rules for processing user-uploaded information and security protection
      measures to ensure that user information is not collected beyond the purpose and scope, to ensure the security of
      user-uploaded information, and to ensure that user-uploaded information is not misused. Our company guarantees
      that it will not disclose or provide users' registration information to third parties, except in the following
      circumstances:
    </div>
    <div class="neirong">
      (1) Relevant legal provisions or the company's legal service procedures;
    </div>
    <div class="neirong">
      (2) In emergency situations, to safeguard the rights and interests of users and the public;
    </div>
    <div class="neirong">
      (3) Other circumstances where personal information needs to be disclosed, edited or revealed in accordance with
      the law.
    </div>
    <div class="neirong" style="font-weight: bold;">
      5. Exemption and Limitation of Liability
    </div>
    <div class="neirong">
      5.1 This software has undergone detailed testing, but it cannot be guaranteed to be fully compatible with all
      software and hardware systems, nor can it be guaranteed that this software is completely error-free. In case of
      incompatibility or software errors, users can call the technical support hotline or log in to our company's
      official website to report the situation to our company and obtain technical support. If the compatibility issue
      cannot be resolved, users can delete this software.
    </div>
    <div class="neirong">
      5.2 The risk of using this software product is borne by the user themselves. To the fullest extent permitted by
      applicable law, the Company shall not be liable for any damage or risk arising from the use or inability to use
      this software, including but not limited to direct or indirect personal damage, loss of business profits,
      interruption of trade, loss of business information or any other economic loss.
    </div>
    <div class="neirong">
      5.3 Our company does not guarantee that it will definitely meet the user's usage requirements and expectations.
      There is no guarantee of being free from interference or malicious attacks. The service quality is not guaranteed
      to be timely, safe, reliable or error-free.
    </div>
    <div class="neirong">
      5.4 In the event that the user's account or password is lost, information is leaked, data is lost, or the account
      is banned or closed for cleaning up due to illegal acts such as recording, Posting, transmitting, sharing,
      sharing, or using, or other negligent behaviors, the user shall bear the relevant consequences and corresponding
      legal responsibilities by themselves.
    </div>
    <div class="neirong">
      5.5 The Company shall not be held responsible for any losses arising from telecommunications system or Internet
      network failures, operating system failures or viruses, information damage or loss, operating system issues or any
      other force majeure reasons.
    </div>
    <div class="neirong">
      5.6 If the user violates the provisions of this agreement, the Company reserves the right to take measures
      including but not limited to suspending the use license, ceasing to provide services, restricting use, and legal
      action.
    </div>
    <div class="neirong" style="font-weight: bold;">
      6. Law and Dispute Resolution
    </div>
    <div class="neirong">
      6.1 This agreement is governed by the laws of the People's Republic of China.
    </div>
    <div class="neirong">
      6.2 Any dispute arising from or in connection with this agreement shall be settled through friendly consultation
      by all parties; If the negotiation fails, either party may submit the relevant dispute to the court where the
      defendant resides for resolution.
    </div>
    <div class="neirong" style="font-weight: bold;">
      7. Other terms
    </div>
    <div class="neirong">
      7.1 If any provision of this Agreement is, for any reason, wholly or partially invalid or unenforceable, or
      violates any applicable law, such provision shall be deemed deleted, but the remaining provisions of this
      Agreement shall remain valid and binding.
    </div>
    <div class="neirong">
      7.2 The Company reserves the right to modify this agreement in accordance with changes in relevant laws and
      regulations, as well as adjustments in the company's business conditions and business strategies. The revised
      agreement will be published on the company's official website and included in the new version of the software. In
      the event of any dispute, the latest agreement text shall prevail. If the user continues to use this software, it
      shall be deemed that you accept the changes to this agreement.
    </div>
    <div class="neirong">
      7.3 The Company reserves the right to send notifications, advertisements, etc. to users through means such as
      Posting notices on the website or sending emails.
    </div>
    <div class="neirong">
      7.4 All notifications to the user under this agreement may be made through web page announcements, client pop-up
      Windows, emails, mobile text messages or regular mail transmission, etc. All notices and announcements shall be
      regarded as part of this agreement. The date of self-delivery of a notice shall be deemed to have been delivered
      to the recipient.
    </div>
    <div class="neirong">
      7.5 The Company reserves the right to interpret and modify this agreement to the fullest extent permitted by law.
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped>
.biaotou {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  margin-bottom: 10px;
}

.biaoti {
  font-size: 24px;
  font-weight: bold;
}

.neirong {
  text-indent: 2em;
  margin: 10px 0px;
}
</style>
